import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DownloadService {
  public downloadFile(blob: Blob, fileName: string): void {
    fileName = fileName.replace(/[/\\?%*:|"<>]/g, "-");

    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
      (window.navigator as any).msSaveOrOpenBlob(blob);

      return;
    }

    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement(
      "a",
    ) as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }
}
